// extracted by mini-css-extract-plugin
module.exports =  {"fields":"TDgfgi","time":"Hdwtkf","mobile":"gIAKeB"};